export default __webpack_public_path__ + "static/avatar-kayi-common-7-detail-23aa8d4f96ac18fb491ffc63c8f9d1b2.png";